// commented 'disabled' ie allowed to edit,  so that Sales Invoice, Customer, Date and PO can be edited, 1-Oct-2025
import React, { useEffect, useState,useRef } from "react";
import {
  Card, Table,AutoComplete,Checkbox,Button,Radio, Modal, Form, Tooltip, Input, InputNumber, Select, DatePicker, message, Row, Col, Popconfirm
} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from '../api/axios';
import moment from "moment";


const { Option } = Select;


export default function SalesInvoice() {
  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [visible, setVisible] = useState(false);

  const [editingInvoice, setEditingInvoice] = useState(null);

  // Invoice Details modal
  const [invoiceDetailVisible, setInvoiceDetailVisible] = useState(false);
  const [invoiceDetail, setInvoiceDetail] = useState(null);
  const [invoiceDetailItems, setInvoiceDetailItems] = useState([]);

  // PO dropdown
  const [poList, setPOList] = useState([]);
  const [selectedPODate, setSelectedPODate] = useState(null);
  const [selectedPORemainingAmount, setSelectedPORemainingAmount] = useState(null);
  //const [filteredPOs, setFilteredPOs] = useState([]);

  // for Client_Update checkbox
  const [data, setData] = useState([]);

    // Loading and filter states
  const [loading, setLoading] = useState([]);
  const [customerFilter, setCustomerFilter] = useState([]);
  const [dateFilter, setDateFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState([]);
  const [destinationFilter, setDestinationFilter] = useState([]);
  const [filterInvoiceNumber, setFilterInvoiceNumber] = useState('');
  const [filterClientUpdated, setFilterClientUpdated] = useState('');

  // check for duplicate Invoice number when Manu
  const [invoiceNumber, setInvoiceNumber] = useState('');  // initially empty
  const [isDuplicate, setIsDuplicate] = useState(null);   // null means no check yet


  const [poNumberFilter, setPONumberFilter] = useState([]);

  // for manual/auto invoice number in Add Sales Invoice
  const [invoiceNumMode, setInvoiceNumMode] = useState("auto");  // 'auto' or 'manual'
  const [manualInvoiceNumber, setManualInvoiceNumber] = React.useState("");
  const [prefix, setPrefix] = React.useState("");

  // for dynamic update of PO_Remaining_Amount
  const [form] = Form.useForm();
  const invoiceItems = Form.useWatch('items', form) || [];

  // for customer combo box
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomerID, setSelectedCustomerID] = useState(null);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [newCustomerData, setNewCustomerData] = useState(null);

    // for allowing manual changes for GST, after SAC code
    const [manualGSTEdit, setManualGSTEdit] = useState({});

    // to gen merged invoice
    const [selectedMergeFiles, setSelectedMergeFiles] = useState({});

    //for delete code
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [deleteCode, setDeleteCode] = useState('');
    const DELETE_CODE = process.env.REACT_APP_DELETE_CODE || 'DEEPAK1234';



    const resetPoFields = () => {
        form.setFieldsValue({ PO_Number: undefined, PO_Date: undefined, PO_Remaining_Amount: undefined });
    };
    //for IGST  or CGST/SGST Radio button
    const [taxType, setTaxType] = useState('IGST'); // Default to IGST

    // PO Dropdown as filtered by customer id
    const filteredPOs = selectedCustomerID ? poList.filter(po => po.CustomerID === selectedCustomerID): poList;

    //Fetch data from SAC_Code table
    const [sacCodes, setSacCodes] = useState([]);
    useEffect(() => {
        api.get('/saccode').then(res => setSacCodes(res.data));
    }, []);


// sort *filtered* invoices based on NAS/ADANI/NNNN with NNNN Descending order
    const sortedFilteredInvoices = [...filteredInvoices].sort((a, b) => {
        const aNum = a.InvoiceNumber || '';
        const bNum = b.InvoiceNumber || '';

        const aIsAdani = aNum.startsWith('NAS/ADANI/');
        const bIsAdani = bNum.startsWith('NAS/ADANI/');

        // 1) All NAS/ADANI first
        if (aIsAdani && !bIsAdani) return -1;
        if (!aIsAdani && bIsAdani) return 1;

        // 2) If both are NAS/ADANI, sort by numeric suffix desc
        if (aIsAdani && bIsAdani) {
            const aSuffix = parseInt(aNum.split('/').pop().replace(/\D/g, ''), 10) || 0;
            const bSuffix = parseInt(bNum.split('/').pop().replace(/\D/g, ''), 10) || 0;
            return bSuffix - aSuffix; // descending
        }

        // 3) Non-ADANI: fall back to InvoiceNumber desc (or 0 to keep original)
        return (bNum || '').localeCompare(aNum || '');
    });



    // Calculate the invoice total dynamically from invoiceItems
  const invoiceTotal = invoiceItems.reduce((acc, item) => {
    if (!item) return acc;
    const rate = Number(item.Rate) || 0;
    const quantity = Number(item.Quantity) || 0;
    const cgst = Number(item.CGST) || 0;
    const sgst = Number(item.SGST) || 0;
    const igst = Number(item.IGST) || 0;
    const taxMultiplier = (cgst + sgst + igst) / 100;
    const total = rate * quantity * (1 + taxMultiplier);
    return acc + total;
  }, 0);


 // fetch POMaster data
    const fetchPOList = async () => {
        try {
            const res = await api.get('/pomaster');
            setPOList(res.data);
        } catch (err) {
            console.error('Failed to fetch PO list:', err);
        }
    };

// Initial load on mount
    useEffect(() => {
        fetchData();
        fetchPOList();
    }, []);

///////////////////////////////////////////////////////////////

    // If invoiceDetail.CustomerID is set initially, reflect in input state
    useEffect(() => {
        if (customers.length && invoiceDetail && invoiceDetail.CustomerID) {
            const cust = customers.find(c => c.CustomerID === invoiceDetail.CustomerID);
            if (cust) {
                setSelectedCustomerID(cust.CustomerID);
                setCustomerInput(formatCustomerOption(cust));
            }
        }
    }, [customers, invoiceDetail]);

//////////   for combo
// fetch customers and set customerOptions like this:
    useEffect(() => {
        fetchCustomers();
   }, []);

    async function fetchCustomers() {
        try {
            const res = await api.get('/customers');
            setCustomers(res.data);
            setCustomerOptions(res.data.map(c => ({
                value: formatCustomerOption(c),
                label: formatCustomerOption(c),
                id: c.CustomerID,
            })));
        } catch(err) {
            message.error('Failed to load customers');
        }
    }
    // Example: auto update input when selectedCustomerID changes
    useEffect(() => {
        if (selectedCustomerID) {
            const selCust = customers.find(c => c.CustomerID === selectedCustomerID);
            if (selCust) {
                const formatted = formatCustomerOption(selCust);
                if (formatted !== customerInput) {
                    setCustomerInput(formatted);
                }
            }
        }
    }, [selectedCustomerID, customers]);


///////////////////

  const fetchData = () => {
    setLoading(true);
    Promise.all([
      api.get("/invoices/sales"),
      api.get("/customers"),
    ])
        .then(([invoiceRes, customerRes]) => {
          setInvoices(invoiceRes.data);
          setFilteredInvoices(invoiceRes.data);
          setCustomers(customerRes.data);
        })
        .catch(e => message.error("Failed to load invoices or customers"))
        .finally(() => setLoading(false));
  };

  const getCustomerName = (id) => {
    const customer = customers.find(c => c.CustomerID === id);
    return customer ? customer.CustomerName : id;
  };

    const getCustomerLocation = (id) => {
        const customer = customers.find(c => c.CustomerID === id);
        return customer ? customer.Location : id;
    };

  const handlePONumberChange = async (poNumber) => {
    if (!poNumber) {
      setSelectedPODate(null);
      setSelectedPORemainingAmount(null);
      form.setFieldsValue({ PO_Date: null, PO_Remaining_Amount: null });
      return;
    }

    try {
      // Make API call to fetch the PO record by PO_Number
      const response = await api.get(`/invoices/by-number/${poNumber}`);
      const poData = response.data;

      // Update component state with latest PO Date and Remaining Amount
      setSelectedPODate(poData.PO_Date || null);
      setSelectedPORemainingAmount(poData.PO_Remaining_Amount || null);

      // Update form fields so the UI reflects latest data
      form.setFieldsValue({
        PO_Date: poData.PO_Date || null,
        PO_Remaining_Amount: poData.PO_Remaining_Amount || null,
      });
    } catch (error) {
      console.error("Failed to fetch PO by PO_Number", error);
      setSelectedPODate(null);
      setSelectedPORemainingAmount(null);
      form.setFieldsValue({ PO_Date: null, PO_Remaining_Amount: null });
    }
  };


    // Sort customers alphabetically by CustomerName only for Customer drop down field in Add Sales Invoice
    const sortedCustomers = [...customers].sort((a, b) =>
        a.CustomerName.localeCompare(b.CustomerName)
    );

  // Filtering logic
  useEffect(() => {
    let data = [...invoices];
    if (customerFilter.length) data = data.filter(inv => customerFilter.includes(inv.CustomerID));
    if (destinationFilter.length) data = data.filter(inv => destinationFilter.includes(inv.Destination));
    if (poNumberFilter.length) data = data.filter(inv => poNumberFilter.includes(inv.PO_Number));
    if (statusFilter.length) data = data.filter(inv => statusFilter.includes(inv.Status));
      if (filterInvoiceNumber) {
          data = data.filter(item =>
              item.InvoiceNumber ? item.InvoiceNumber.toLowerCase().includes(filterInvoiceNumber.toLowerCase()) : false
          );
      }
      if (filterClientUpdated) {
          data = data.filter(item => item.Client_Updated === filterClientUpdated);
      }
    if (dateFilter) {
      const m = dateFilter.match(/^([<>]=?|=)\s*(\d{4}-\d{2}-\d{2})$/);
      if (m) {
        const op = m[1];
        const dateStr = m[2];
        if (op === ">") {
          data = data.filter(inv => moment(inv.Date).isAfter(dateStr, "day"));
        } else if (op === "<") {
          data = data.filter(inv => moment(inv.Date).isBefore(dateStr, "day"));
        } else if (op === ">=") {
          data = data.filter(inv => moment(inv.Date).isSameOrAfter(dateStr, "day"));
        } else if (op === "<=") {
          data = data.filter(inv => moment(inv.Date).isSameOrBefore(dateStr, "day"));
        } else if (op === "=") {
          data = data.filter(inv => moment(inv.Date).isSame(dateStr, "day"));
        }
      }
    }
    setFilteredInvoices(data);
  }, [customerFilter, filterClientUpdated,filterInvoiceNumber,destinationFilter,poNumberFilter,dateFilter, statusFilter, invoices]);

  // View Invoice
  const showInvoiceDetail = (invoiceId) => {
    const invoice = invoices.find(inv => inv.InvoiceID === invoiceId);
    setInvoiceDetail(invoice);
    api.get(`/invoices/sales/${invoiceId}/items`).then(res => {
      setInvoiceDetailItems(res.data);
      setInvoiceDetailVisible(true);
    }).catch(e => message.error("Failed to load invoice items"));
  };

  // Edit Invoice
    const handleEditInvoice = (invoice) => {
        setEditingInvoice(invoice);
        setVisible(true);

        // Find selected customer display string
        const selectedCustomer = customers.find(c => c.CustomerID === invoice.CustomerID);
        const customerDisplay = selectedCustomer
            ? `${selectedCustomer.CustomerName} - ${selectedCustomer.Location}`
            : '';

        api.get(`/invoices/sales/${invoice.InvoiceID}/items`).then(res => {
            form.setFieldsValue({
                ...invoice,
                CustomerID: customerDisplay,                   // Set display string here
                Date: invoice.Date ? moment(invoice.Date) : null,
                PO_Number: invoice.PO_Number || null,
                PO_Date: invoice.PO_Date ? moment(invoice.PO_Date, "YYYY-MM-DD") : null,
                PO_Remaining_Amount: invoice.PO_Remaining_Amount || null,
                items: res.data.length ? res.data : [{}],
                Client_Updated: invoice.Client_Updated || 'N',
            });
            setCustomerInput(customerDisplay);               // Update input state as well
            setSelectedCustomerID(invoice.CustomerID);       // Store actual ID separately

            setSelectedPODate(invoice.PO_Date || null);
            setSelectedPORemainingAmount(invoice.PO_Remaining_Amount || null);
        });
    };


    //// gen merged invoice start
    const handleMergePdfSelect = (e, invoiceID) => {
        console.log('🔍 handleMergePdfSelect called', invoiceID);
        console.log('🔍 Files selected:', e.target.files);

        const file = e.target.files[0];
        if (file && file.type === 'application/pdf') {
            console.log('✅ Valid PDF selected:', file.name, file.size);
            setSelectedMergeFiles(prev => {
                const newState = { ...prev, [invoiceID]: file };
                console.log('🔍 New state:', newState);
                return newState;
            });
            message.success(`PDF selected for invoice ${invoiceID}`);
        } else {
            console.error('❌ Invalid file:', file);
            message.error('Please select a valid PDF file');
            e.target.value = '';
        }
    };

    const generateMergedPdf = async (invoiceID) => {
        console.log('🚀 generateMergedPdf clicked for:', invoiceID);

        const file = selectedMergeFiles[invoiceID];
        //alert(`🔍 Selected file: ${file ? file.name : 'No file'}`);

        if (!file) {
            console.log('⚠️ No file found in state');
            message.warning('Please select a PDF file first');
            return;
        }

        const formData = new FormData();
        formData.append('attachmentPdf', file);
        //alert('📤 FormData prepared, sending request...');

        try {
            message.loading('Generating merged invoice PDF...', 0);

            const token = localStorage.getItem('token');

            const response = await api.post(`/invoices/sales/${invoiceID}/pdf/merge`,
                formData,
                {
                    responseType: 'blob',
                    headers: { 'Content-Type': 'multipart/form-data',
                               'Authorization': `Bearer ${token}`
                    }
                }
            );
            //alert('✅ Backend response received');

            // Download code...
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.download = `merged_invoice_${invoiceID}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            message.success('Merged PDF downloaded successfully!');
            setSelectedMergeFiles(prev => ({ ...prev, [invoiceID]: null }));

        } catch (error) {
            console.error('❌ Merge PDF error:', error);
            console.error('❌ Response:', error.response);
            message.error('Failed to generate merged PDF');
        } finally {
            message.destroy();
        }
    };

    // Clear PDF selection for specific invoice
    const clearMergeSelection = (invoiceID) => {
        setSelectedMergeFiles(prev => ({
            ...prev,
            [invoiceID]: null
        }));
    };
    //// gen merged invoice  ends

    // Delete Invoice,Delete Invoice with invoice total passed to backend
  const handleDeleteInvoice = (invoiceId, invoiceTotal, poNumber) => {
    api.delete(`/invoices/sales/${invoiceId}`, {
      params: {
        invoiceTotal: invoiceTotal,
        poNumber: poNumber,
      },
    })
        .then(() => {
          message.success("Invoice deleted and PO Remaining Amount updated!");
            setShowDeleteModal(false);
            setDeleteCode('');
            fetchData();
        })
        .catch(e => {
          message.error("Failed to delete invoice: " + (e.response?.data?.error || e.message));
        });
  };

// check for duplicate Invoice  in Manual mode
    const checkInvoiceDuplicate = async ( invoiceNum) => {
        if (invoiceNumMode !== 'manual' || !invoiceNum) {
            setIsDuplicate(null);
            return;
        }
        try {
            const res = await api.get(`/invoices/salesinvoice/check-duplicate?invoiceNumber=${invoiceNum}`);
            setIsDuplicate(res.data.count > 0);
        } catch {
            setIsDuplicate(null);
        }
    };

    const onInvoiceNumberChange = (e) => {
        const val = e.target.value;
        setInvoiceNumber(val);
        checkInvoiceDuplicate(val);
    };

  // Add/Edit Invoice
  const onFinish = (values) => {
      console.log("inside onFinish", values);
      // Validate invoiceNumMode exists on form (add mode)
    if (!editingInvoice && !values.invoiceNumMode) {
      message.error("Select Invoice Number Mode (Auto or Manual).");
      return;
    }
    // For manual mode, InvoiceNumber must be present
    if (!editingInvoice && values.invoiceNumMode === "manual" && !values.InvoiceNumber) {
      message.error("Invoice Number is required in Manual mode.");
      return;
    }

    const items = values.items.map(item => {
      const rate = Number(item.Rate) || 0;
      const quantity = Number(item.Quantity) || 0;
      const cgst = Number(item.CGST) || 0;
      const sgst = Number(item.SGST) || 0;
      const igst = Number(item.IGST) || 0;
      const rateAmount = rate * quantity;
      const taxAmount = rateAmount * (cgst + sgst + igst) / 100;
      const total = rateAmount + taxAmount;
      return {
        ...item,
        RateAmount: rateAmount,
        TaxAmount: taxAmount,
        Total: total,
        CGST: cgst,
        SGST: sgst,
        IGST: igst,
      };
    });



    // Invoice-level sums
    const invoiceRateAmount = items.reduce((sum, item) => sum + item.RateAmount, 0);
    const invoiceTaxAmount = items.reduce((sum, item) => sum + item.TaxAmount, 0);
    const invoiceTotal = Math.round(items.reduce((sum, item) => sum + item.Total, 0));

     const payload = {
      // CustomerID: values.CustomerID,
      CustomerID: selectedCustomerID,
      Date: values.Date.format("YYYY-MM-DD"),
      Items: items,
      RateAmount: invoiceRateAmount,
      TaxAmount: invoiceTaxAmount,
      TotalAmount: invoiceTotal,
      AmountReceived: 0,
      Status: "Pending",
      Remarks: "",
      RefNoDate: values.RefNoDate,
      OtherReference: values.OtherReference,
      PO_Number: values.PO_Number,
      PO_Date: values.PO_Date ? values.PO_Date : null,
      PO_Remaining_Amount: values.PO_Remaining_Amount ? values.PO_Remaining_Amount : null,
      Dispatched_Via: values.Dispatched_Via,
      Destination: values.Destination,
      oldInvoiceTotal: editingInvoice ? editingInvoice.TotalAmount : 0,
    };

    // payload values based on auto/manual for invoiceNumber
    if (!editingInvoice) {
      // Add InvoiceNumMode for backend
      payload.invoiceNumMode = values.invoiceNumMode;
      if (values.invoiceNumMode === "auto") {
        // Send Prefix only, backend generates InvoiceNumber
        payload.Prefix = values.Prefix;
        // Do NOT send InvoiceNumber field to backend to avoid confusion
      } else if (values.invoiceNumMode === "manual") {
        // Send Manual InvoiceNumber entered by user
        payload.InvoiceNumber = values.InvoiceNumber;
        // You can optionally send Prefix as empty string or omit it
        payload.Prefix = "";
      }
    } else {
      //new invoice total > po remaining amount + old invoice total
      if (invoiceTotal > values.PO_Remaining_Amount + editingInvoice.TotalAmount) {
        // Show alert similar to Add Sales Invoice
        const userConfirmed = window.confirm(
            "Current Invoice Total is more than PO Remaining Amount. Please confirm or Cancel Invoice Update."
        );
        if (!userConfirmed) {
          return; // Cancel submission if user rejects
        }
      }
        payload.InvoiceNumber = editingInvoice.InvoiceNumber;
    }

      //alert(`on salesInvoice submit: "${payload.CustomerID}"`);


    const submitInvoice = () => {
      const req = editingInvoice
          ? api.put(`/invoices/sales/${editingInvoice.InvoiceID}`, payload)
          : api.post("/invoices/sales", payload);

      req.then((res) => {
        message.success(`Sales invoice ${editingInvoice ? "updated" : "added"}! Invoice Number: ${res.data.InvoiceNumber}`);
        setVisible(false);
        setEditingInvoice(null);
        form.resetFields();
        fetchData();
      }).catch(e => {
        message.error("Error saving invoice: " + (e.response?.data?.error || e.message));
      });
    };

    if (!editingInvoice && invoiceTotal > selectedPORemainingAmount) {
      const userConfirmed = window.confirm(
          "Current Invoice Total is more than PO Remaining Amount. Please confirm or Cancel Invoice Creation."
      );
      if (!userConfirmed) {
        // User clicked Cancel, do not proceed
        return;
      }
      // User confirmed, proceed with submitting invoice
      submitInvoice();
    } else {
      submitInvoice();
    }

  };

  // Table columns
  const columns = [
    { title: "Invoice Number", dataIndex: "InvoiceNumber", sorter: (a, b) => a.InvoiceNumber.localeCompare(b.InvoiceNumber) },
    { title: "Customer", dataIndex: "CustomerID", render: (id) => getCustomerName(id), sorter: (a, b) => getCustomerName(a.CustomerID).localeCompare(getCustomerName(b.CustomerID)) },
    { title: "Location", dataIndex: "CustomerID", render: (id) => getCustomerLocation(id), sorter: (a, b) => getCustomerLocation(a.CustomerID).localeCompare(getCustomerLocation(b.CustomerID)) },
    { title: "Date", dataIndex: "Date", sorter: (a, b) => moment(a.Date).unix() - moment(b.Date).unix() },
    { title: "PO Number", dataIndex: "PO_Number", sorter: (a, b) => (a.PO_Number || "").localeCompare(b.PO_Number || "") }, // <-- Added
    {title: 'Destination',dataIndex: 'Destination',sorter: (a, b) => (a.Destination || '').localeCompare(b.Destination || ''),render: v => <span>{v}</span>,},
      {
          title: 'Client Updated',
          dataIndex: 'Client_Updated',
          render: (val, record) => (
              <Checkbox
                  checked={val === 'Y'}
                  onChange={async (e) => {
                      const newValue = e.target.checked ? 'Y' : 'N';
                      try {
                          await api.put(`/invoices/salesinvoice/${record.InvoiceID}/client-updated`, { Client_Updated: newValue });
                            // Update local state directly to reflect change immediately
                          fetchData(); // refresh data list
                          message.success('Client Updated field updated');
                      } catch (error) {
                          message.error('Failed to update Client Updated field');
                      }
                  }}
              />
          ),
      },

    { title: "Total Amount", dataIndex: "TotalAmount", render: (value) => Math.round(value), sorter: (a, b) => a.TotalAmount - b.TotalAmount },
    { title: "Status", dataIndex: "Status", filters: [
    { text: "Pending", value: "Pending" },
    { text: "Partial", value: "Partial" },
    { text: "Full", value: "Full" }
      ],
      onFilter: (value, record) => record.Status === value
    },

      //////////////const isFull = record.Status === "Full";
      {
          title: "Actions",
          render: (_, record) => {
              const isStatusFull = record.Status === 'Full';
              const isGenPdf = record.Gen_PDF === 1;

              // Disable Edit if Status Full OR Gen_PDF=1 when not Full
              const disableEdit = isStatusFull || (!isStatusFull && isGenPdf);

              // Disable Delete only if Status Full
              const disableDelete = isStatusFull;

              return (
                  <>
                      <Tooltip title={disableEdit ? "Editing disabled" : "Edit this invoice"}>
                          <Button
                              type="link"
                              icon={<EditOutlined />}
                              onClick={() => handleEditInvoice(record)}
                          >
                              Edit
                          </Button>
                      </Tooltip>

                      <Button
                          type="link"
                          icon={<DeleteOutlined />}
                          danger
                          onClick={() => {
                              setCurrentRecord(record);
                              setShowDeleteModal(true);
                          }}
                      >
                          Delete
                      </Button>

                      <Tooltip title="View this invoice">
                          <Button
                              type="link"
                              onClick={() => showInvoiceDetail(record.InvoiceID)}
                          >
                              View
                          </Button>
                      </Tooltip>

                      {/* Proforma Invoice button */}
                      <Button
                          type="link"
                          href={`/invoices/sales/${record.InvoiceID}/proforma-pdf`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#13c2c2", marginLeft: 8 }}
                      >
                          Proforma Invoice
                      </Button>

                      <Tooltip title="Generate this invoice">
                          <Button
                              type="link"
                              href={`/invoices/sales/${record.InvoiceID}/pdf`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#722ed1", marginLeft: 8 }}
                          >
                              Generate Invoice
                          </Button>
                      </Tooltip>

                      {/* ✅ FIXED Merge PDF Button */}
                      {selectedMergeFiles[record.InvoiceID] ? (
                          // PDF selected - show Generate Merged PDF + Cancel
                          <>
                              <Tooltip title="Generate invoice + selected PDF">
                                  <Button
                                      type="link"
                                      style={{ color: "#52c41a", marginLeft: 8 }}
                                      onClick={() => generateMergedPdf(record.InvoiceID)}
                                  >
                                      Generate Merged PDF
                                  </Button>
                              </Tooltip>
                              <Tooltip title="Clear PDF selection">
                                  <Button
                                      type="link"
                                      style={{ color: "#ff4d4f", marginLeft: 4 }}
                                      onClick={() => clearMergeSelection(record.InvoiceID)}
                                  >
                                      Cancel
                                  </Button>
                              </Tooltip>
                          </>
                      ) : (
                          // No PDF selected - FIXED file chooser
                          <>
                              <input
                                  id={`merge-pdf-input-${record.InvoiceID}`}  // ✅ Unique ID
                                  type="file"
                                  accept="application/pdf"
                                  onChange={(e) => handleMergePdfSelect(e, record.InvoiceID)}
                                  style={{ display: 'none' }}
                              />
                              <Tooltip title="Select PDF to append after invoice">
                                  <label
                                      htmlFor={`merge-pdf-input-${record.InvoiceID}`}  // ✅ Matches input ID
                                      style={{
                                          display: 'inline-block',
                                          marginLeft: 8,
                                          cursor: 'pointer',
                                          padding: '4px 8px',
                                          border: '1px solid #1890ff',
                                          borderRadius: '4px',
                                          backgroundColor: '#f0f5ff',
                                          color: '#1890ff',
                                          fontSize: '12px',
                                          fontWeight: 500
                                      }}
                                  >
                                      Merge PDF
                                  </label>
                              </Tooltip>
                          </>
                      )}
                  </>
              );

          }
      }

  ];



// combo handler start
// Handler called when a customer option is selected from the dropdown/autocomplete
    const [customerInput, setCustomerInput] = useState('');
    useEffect(() => {
        //alert(`customerInput changed: "${customerInput}"`);
    }, [customerInput]);

    /*
    const onCustomerSelect = (value) => {
        const cust = customers.find(c => formatCustomerOption(c) === value);
        if (cust) {
            setSelectedCustomerID(cust.CustomerID);
            setCustomerInput(value);
            resetPoFields();
        }
    };
     */

    const onCustomerSelect = (value, option) => {
  // 'value' is display string: e.g. "Anand5 - Pune"
  // 'option' is the full option object: {value, label, id}

  if (option && option.id) {
    setSelectedCustomerID(option.id);  // Set the actual CustomerID
  } else {
    // Fallback: try to find customer by display text if needed
    const cust = customers.find(c => formatCustomerOption(c) === value);
    if (cust) {
      setSelectedCustomerID(cust.CustomerID);
    }
  }

  // Update input display text anyway
  setCustomerInput(value);

  resetPoFields(); // clear PO fields on customer change
}

// Called when typing changes input, just update state
    const onCustomerChange = (data) => {
        setCustomerInput(data);
       // alert(`inside onCustomerChange : "${data}"`);
    };

// Called only on Enter key press to check for new customer and confirm insert
    const onCustomerKeyDown = (e) => {
        if (e.key === 'Enter') {
            //alert ("on Enter key");
            //alert(`isCheckingRef.current = ${isCheckingRef.current}`);
            e.preventDefault();
            if (!isCheckingRef.current) {
                handleNewCustomerCheck();
            }
        }
    };

    const isCheckingRef = useRef(false);

    const handleNewCustomerCheck = () => {
        //alert ("inside handleNewCustomerCheck ");
        if (isCheckingRef.current) {
            console.log('handleNewCustomerCheck skipped; already running');
            //alert('handleNewCustomerCheck skipped; already running');
            return;
        }
        isCheckingRef.current = true;

        // Safe formatter for dropdown option to avoid 'undefined - undefined'
        const safeFormatCustomerOption = (cust) => {
            const name = cust?.CustomerName?.trim() || "";
            const location = cust?.Location?.trim() || "";
            if (!name || !location) return "";  // skip invalid entries
            return `${name} - ${location}`;
        };

// Parse input string "Name|Location|Address|PAN|GST" to "Name - Location"
        const formatInputToDropdown = (input) => {
            const parts = input.split('|').map(p => p.trim());
            if (parts.length < 2) return "";
            const [name, location] = parts;
            if (!name || !location) return "";
            return `${name} - ${location}`;
        };

        const formattedInput = formatInputToDropdown(customerInput);

        //alert(`Formatted input for comparison: "${formattedInput}"`);

        const matched = customers.find(c => {
            const formattedOption = safeFormatCustomerOption(c);
            // Skip empty formatted options
            if (!formattedOption) return false;

            //alert(`Comparing "${formattedOption}" with "${formattedInput}"`);
            return formattedOption === formattedInput;
        });

        //alert(`Matched customer: ${matched ? JSON.stringify(matched) : 'none'}`);

        if (matched) {
            setSelectedCustomerID(matched.CustomerID);
            alert(`Customer exists with customer ID: ${matched.CustomerID}, add new or select from drop down`);
            isCheckingRef.current = false;
            return;
        }

        const parts = customerInput.split('|').map(p => p.trim());
        //alert(`Split parts count: ${parts.length}, parts: ${parts.join(', ')}`);
        if (parts.length !== 5) {
            alert('Input does not have exactly 5 parts separated by "|" - aborting modal.');
            isCheckingRef.current = false;
            return;
        }

        const [CustomerName, Location, CustomerAddress, PAN, GST] = parts;
        //alert(`Confirm modal for: ${CustomerName}, ${Location}, ${Address}, ${PAN}, ${GST}`);
        setNewCustomerData({ CustomerName, Location, CustomerAddress, PAN, GST });
        setConfirmVisible(true);

    };



    const formatCustomerOption = (cust) => {
        const name = cust?.CustomerName?.trim() || '';
        const location = cust?.Location?.trim() || '';
        return name && location ? `${name} - ${location}` : '';
    };

    const onConfirmOk = async () => {
        try {
            //alert("API Call for Insert");
            isCheckingRef.current = true;

            const { CustomerName, Location, CustomerAddress, PAN, GST } = newCustomerData;

            // Insert new customer
            const insertResponse = await api.post('/customers', { CustomerName,CustomerAddress, GST,PAN,Location });

            // Fetch updated customers list from DB (newest first)
            const res = await api.get('/customers');
            const updatedCustomers = res.data;

            // Update customers state
            setCustomers(updatedCustomers);

            // Rebuild dropdown options with formatted values
            setCustomerOptions(
                updatedCustomers
                    .map(c => ({
                        value: formatCustomerOption(c),
                        label: formatCustomerOption(c),
                        id: c.CustomerID,
                    }))
                    .filter(opt => opt.value)  // filter out invalid options
            );

            // Find the newly inserted customer by ID returned from insert API
            const insertedCustomerID = insertResponse.data.CustomerID || insertResponse.data.id;
            const insertedCustomer = updatedCustomers.find(c => c.CustomerID === insertedCustomerID);

            if (insertedCustomer) {
                const displayText = formatCustomerOption(insertedCustomer);
                setCustomerInput('');
                //alert(`Input cleared. Current customerInput: "${customerInput}"`);
                //alert(`CustomerID: "${insertedCustomerID}"`);
                setSelectedCustomerID(insertedCustomer.CustomerID);
            } else {
                alert("inside fallback");
                setCustomerInput('');
                setSelectedCustomerID(null);
                message.warning('Inserted customer not found in refreshed list.');
            }
           resetPoFields();

            // Insert default PO record via API
            const insertPOResponse = await api.post('/pomaster', {
                PO_Number: CustomerName,
                CustomerID: insertedCustomerID,
                PO_Date: new Date().toISOString().substring(0, 10),
                PO_Desc: 'default PO',
                PO_Amount: 0,
                PO_Remaining_Amount: 0,
                CustomerName: CustomerName,
                Location: Location,
                // other fields if required
            });

            await fetchPOList();  // refresh PO list after insert


            message.success('New customer added and selected');
        } catch (error) {
            message.error('Failed to add new customer');
        } finally {
            isCheckingRef.current = false;
            setConfirmVisible(false);
        }
    };


// combo handler end

    return (
        <>
      <Card title="Sales Invoices" extra={
        <Button type="primary" onClick={() => {
          setVisible(true);
          setEditingInvoice(null);
          form.resetFields();
          setSelectedPODate(null);
          setSelectedPORemainingAmount(null);
        }}>
          Add Sales Invoice
        </Button>
      }>
        {/* Filter Controls */}
        <Row gutter={8} style={{ marginBottom: 16 }}>
          <Col>
              <Input
                  placeholder="Filter Invoice Number"
                  value={filterInvoiceNumber}
                  onChange={e => setFilterInvoiceNumber(e.target.value)}
                  allowClear
              />
          </Col>
          <Col>
            <Select
                showSearch
                mode="multiple"
                allowClear
                placeholder="Filter by Customer"
                style={{ width: 200 }}
                value={customerFilter}
                onChange={setCustomerFilter}
                filterOption={(input, option) =>
                    option.children.toLowerCase().startsWith(input.toLowerCase())
                }
            >
              {customers.map(s => (
                  <Option value={s.CustomerID} key={s.CustomerID}>{s.CustomerName}</Option>
              ))}
            </Select>
          </Col>
          <Col>
            <Tooltip title="Type: >2025-01-01, <2025-01-01, >=2025-01-01, =2025-01-01">
              <Input
                  placeholder="Date (e.g. >2025-01-01)"
                  value={dateFilter}
                  onChange={e => setDateFilter(e.target.value)}
                  style={{ width: 170 }}
              />
            </Tooltip>
          </Col>
          <Col>
            <Select
                showSearch
                mode="multiple"
                allowClear
                placeholder="Filter by PO Number"
                style={{ width: 160 }}
                value={poNumberFilter}
                onChange={setPONumberFilter}
                filterOption={(input, option) =>
                    option.children.toLowerCase().startsWith(input.toLowerCase())
                }
            >
              {Array.from(new Set(invoices.map(inv => inv.PO_Number)))
                  .filter(Boolean)
                  .map(po => (
                      <Option value={po} key={po}>{po}</Option>
                  ))}
            </Select>
          </Col>
            <Col>
                <Select
                    allowClear
                    mode="multiple"
                    placeholder="Filter by Status"
                    style={{ width: 140 }}
                    onChange={val => setStatusFilter(val)}
                    value={statusFilter}
                >
                    <Option value="Pending">Pending</Option>
                    <Option value="Partial">Partial</Option>
                    <Option value="Full">Full</Option>
                </Select>
            </Col>
            <Col>
                <Select
                    value={filterClientUpdated}
                    placeholder="Filter by Client_Updated"
                    onChange={setFilterClientUpdated}
                    allowClear
                    style={{ width: 160 }}
                >
                    <Option value="Y">Yes</Option>
                    <Option value="N">No</Option>
                </Select>
            </Col>
            <Col>
            <Select
                showSearch
                mode="multiple"
                allowClear
                placeholder="Filter by Destination"
                style={{ width: 180 }}
                value={destinationFilter}
                onChange={setDestinationFilter}
                filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                }
            >
              {Array.from(new Set(invoices.map(inv => inv.Destination)))
                  .filter(Boolean)
                  .map(dest => (
                      <Option value={dest} key={dest}>
                        {dest}
                      </Option>
                  ))}
            </Select>
          </Col>


          <Col>
            <Button onClick={() => {
              setCustomerFilter([]);
              setDateFilter("");
              setStatusFilter([]);
              setDestinationFilter([]);
              setPONumberFilter([]);

            }}>Reset</Button>
          </Col>
        </Row>

        <Table
            dataSource={sortedFilteredInvoices}
            columns={columns}
            rowKey="InvoiceID"
            pagination={{ pageSize: 10 }}
            loading={loading}
        />

          {/*} Modal for confirming delete of an invoice */}
          <Modal
              title="Confirm Delete"
              open={showDeleteModal}
              onCancel={() => {
                  setShowDeleteModal(false);
                  setDeleteCode('');
              }}
              footer={null}
          >
              <p><strong>Delete invoice?</strong></p>
              <p>Invoice Number: {currentRecord?.InvoiceNumber}</p>
              <p>PO: {currentRecord?.PO_Number}</p>
              <Input.Password
                  placeholder="Enter delete code"
                  value={deleteCode}
                  onChange={(e) => setDeleteCode(e.target.value)}
                  style={{ margin: '16px 0' }}
                  onPressEnter={() => handleDeleteInvoice(
                      currentRecord?.InvoiceID,
                      currentRecord?.TotalAmount,
                      currentRecord?.PO_Number
                      )}
              />
              <div style={{ textAlign: 'right' }}>
                  <Button onClick={() => setShowDeleteModal(false)} style={{ marginRight: 8 }}>
                      Cancel
                  </Button>
                  <Button
                      type="primary"
                      danger
                      disabled={deleteCode !== DELETE_CODE}
                      onClick={() => handleDeleteInvoice(                                      currentRecord?.InvoiceID,
                          currentRecord?.TotalAmount,
                          currentRecord?.PO_Number
                          )}
                  >
                      Delete Invoice
                  </Button>
              </div>
          </Modal>

        {/* Add/Edit Invoice Modal */}
        <Modal
            open={visible}
            onCancel={() => {
              setVisible(false);
              setEditingInvoice(null);
              form.resetFields();
              setSelectedPODate(null);
              setSelectedPORemainingAmount(null);
              isCheckingRef.current = false;
            }}
            onOk={() => form.submit()}
            title={editingInvoice ? "Edit Sales Invoice" : "Add Sales Invoice"}
            width={1500}
            destroyOnClose
        >

          <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              initialValues={{ Client_Updated: 'N',items: [{}] }}
          >
            <Row gutter={24}>
              <Col span={12}>
                  <Form.Item
                      name="CustomerID"
                      label="Customer (or add new as Name|Locatio|Address|PAN|GST)"
                      rules={[{ required: true, message: 'Please select or enter a customer' }]}
                  >
                      <AutoComplete
                          options={customerOptions}
                          style={{ width: 650 }}
                          value={customerInput}
                          onSelect={onCustomerSelect}
                          onChange={onCustomerChange}
                          filterOption={(inputValue, option) =>
                              option.value.toLowerCase().includes(inputValue.toLowerCase())
                          }
                          placeholder="Select existing or type new customer (Name|Location|Address|PAN|GST)"
                          //disabled={!!editingInvoice}
                      >
                          <Input onKeyDown={onCustomerKeyDown} />
                      </AutoComplete>
                  </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="Date" label="Date" rules={[{ required: true }]}>
                  <DatePicker
                      //disabled={!!editingInvoice}
                      style={{ width: "80%" }} />
                </Form.Item>
              </Col>
              <Col span={9}>
                {editingInvoice ? (
                    <Form.Item label="Invoice Number">
                      <Input
                          value={editingInvoice.InvoiceNumber}
                          readOnly
                          style={{ backgroundColor: "#f5f5f5", color: "#888" }}
                      />
                    </Form.Item>
                ) : (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
                            <Form.Item
                                name="invoiceNumMode"
                                label="Invoice Number Mode"
                                initialValue="auto"
                                rules={[{ required: true, message: "Please select invoice number mode" }]}
                                style={{ marginBottom: 0 }}
                            >
                                <Radio.Group
                                    onChange={e => {
                                        const mode = e.target.value;
                                        setInvoiceNumMode(mode);
                                        if (mode === "auto") {
                                            form.setFieldsValue({ InvoiceNumber: "" }); // Clear, backend will handle
                                        }
                                        setManualInvoiceNumber("");
                                    }}
                                    value={invoiceNumMode}
                                >
                                    <Radio value="auto">Auto (NAS/ADANI/XXXX)</Radio>
                                    <Radio value="manual">Manual</Radio>
                                </Radio.Group>
                            </Form.Item>

                            {invoiceNumMode === "auto" ? (
                                <Form.Item
                                    name="InvoiceNumber"
                                    label={<span style={{ fontWeight: 'bold' }}>Invoice Number</span>}
                                    rules={[{ required: false, message: 'Auto-generated in backend' }]}
                                >
                                    <Input disabled placeholder="Will be auto-generated (NAS/ADANI/XXXX)" />
                                </Form.Item>
                            ) : (
                                <Form.Item
                                    name="InvoiceNumber"
                                    label={
                                        <span style={{ fontWeight: 'bold' }}>
                                            Invoice Number{' '}
                                            {isDuplicate === null ? null : isDuplicate ? (
                                                <span style={{ color: 'red' }}>Duplicate=Y</span>
                                            ) : (
                                                <span style={{ color: 'green' }}>Duplicate=N</span>
                                            )}
                                        </span>
                                    }
                                    rules={[{ required: true, message: 'Please enter Invoice Number' }]}
                                >
                                    <Input
                                        disabled={!!editingInvoice}
                                        placeholder="Enter Invoice Number (alphanumeric)"
                                        value={invoiceNumber}
                                        onChange={onInvoiceNumberChange}
                                    />
                                </Form.Item>
                            )}
                        </div>
                    </>

                )}

              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={6}>
                  <Form.Item
                      name="PO_Number"
                      label="PO Number"
                      rules={[{ required: true }]}
                  >
                      <Select
                          placeholder="Select PO Number"
                          //disabled={!!editingInvoice}  // disable when editing
                          onChange={(value) => {
                              const po = poList.find(p => p.PO_Number === value);
                              if (po && po.PO_Date) {
                                  form.setFieldsValue({
                                      PO_Date: moment(po.PO_Date, "YYYY-MM-DD"),
                                      PO_Remaining_Amount: po.PO_Remaining_Amount,
                                  });
                                  setSelectedPORemainingAmount(Number(po.PO_Remaining_Amount));
                              } else {
                                  form.setFieldsValue({
                                      PO_Date: undefined,
                                      PO_Remaining_Amount: undefined,
                                  });
                                  setSelectedPORemainingAmount(null);
                              }
                          }}
                      >
                          {filteredPOs.map(po => (
                              <Select.Option key={po.PO_Number} value={po.PO_Number}>
                                  {po.PO_Number}
                              </Select.Option>
                          ))}
                      </Select>

                  </Form.Item>


              </Col>
              <Col span={6}>
                  <Form.Item name="PO_Date" label="PO Date">
                      <DatePicker
                          disabled
                          style={{ width: "100%" }}
                          format="YYYY-MM-DD"
                      />
                  </Form.Item>

              </Col>
              <Col>
              <Form.Item
                  name="PO_Remaining_Amount"
                  label={<span style={{ fontWeight: 'bold' }}>PO Remaining Amount</span>}
              >
                <Input value={(typeof selectedPORemainingAmount === 'number' ? selectedPORemainingAmount : 0).toFixed(2)} disabled />
              </Form.Item>
              </Col>
              <Col>
                  <Form.Item
                      name="Client_Updated"
                      label="Client Updated"
                      //rules={[{ required: true, message: 'Please select Client Updated status' }]}
                  >
                      <Radio.Group>
                          <Radio value="Y">Y</Radio>
                          <Radio value="N">N</Radio>
                      </Radio.Group>
                  </Form.Item>
              </Col>
            </Row>
              <Row gutter={16}>

              <Col span={6}>
                <Form.Item name="Dispatched_Via" label="Dispatched Via">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="Destination" label="Destination">
                  <Input />
                </Form.Item>
              </Col>
                  <Col>
                      <Form.Item label="Tax Type" style={{ marginLeft: 16 }}>
                          <Radio.Group
                              value={taxType}
                              onChange={e => setTaxType(e.target.value)}
                              options={[
                                  { label: "IGST", value: "IGST" },
                                  { label: "CGST/SGST", value: "CGST_SGST" }
                              ]}
                              optionType="button"
                              buttonStyle="solid"
                          />
                      </Form.Item>
                  </Col>
            </Row>
              <Form.List name="items">
                  {(fields, { add, remove }) => (
                      <>
                          {/* Header row */}
                          <div style={{
                              display: 'flex',
                              fontWeight: 'bold',
                              marginBottom: 8,
                              gap: 8,                // Slightly increased gap for clarity
                              paddingRight: 16,      // Right padding to balance Remove button
                              alignItems: 'center',  // Vertically center align labels
                              userSelect: 'none',
                          }}>
                              <div style={{ flex: 2.5 }}>Item Name</div>
                              <div style={{ flex: 1.7, textAlign: 'center' }}>UOM</div>
                              <div style={{ flex: 1, textAlign: 'center' }}>SAC</div>
                              <div style={{ flex: 1.5, textAlign: 'center' }}>Rate</div>
                              <div style={{ flex: 1.5, textAlign: 'center' }}>Qty</div>
                              <div style={{ flex: 1, textAlign: 'center' }}>CGST%</div>
                              <div style={{ flex: 1, textAlign: 'center' }}>SGST%</div>
                              <div style={{ flex: .75, textAlign: 'center' }}>IGST%</div>
                              <div style={{ flex: 1, textAlign: 'center' }}>Total</div>
                              <div style={{ width: 60, textAlign: 'center' }}>Remove</div>
                          </div>

                          {/* Item fields rows */}
                          {fields.map(({ key, name, ...restField }) => (
                              <div
                                  key={key}
                                  style={{
                                      display: 'flex',
                                      gap: 8,
                                      marginBottom: 12,
                                      alignItems: 'center',  // Vertically align inputs
                                      paddingRight: 16,      // Right padding aligned with header
                                  }}
                              >
                                  <Form.Item
                                      {...restField}
                                      name={[name, "ItemName"]}
                                      rules={[{ required: true, message: "Item Name is required" }]}
                                      style={{ flex: 3, marginBottom: 0 }}
                                  >
                                      <Input placeholder="Item Name" />
                                  </Form.Item>

                                  <Form.Item
                                      {...restField}
                                      name={[name, "UOM"]}
                                      style={{ flex: 1.5, marginBottom: 0 }}
                                  >
                                      <Input placeholder="UOM" />
                                  </Form.Item>

                                  <Form.Item
                                      {...restField}
                                      name={[name, "SAC_Code"]}
                                      style={{ flex: 1.5, marginBottom: 0 }}
                                      rules={[{ required: true, message: "Please select a SAC Code" }]}
                                  >
                                      <Select
                                          placeholder="SAC"
                                          showSearch
                                          optionFilterProp="children"
                                          // onChange handler as before
                                          onChange={(value) => {
                                              // Reset manual edit flags for this row for GST fields
                                              setManualGSTEdit(prev => {
                                                  const copy = { ...prev };
                                                  delete copy[`${name}-IGST`];
                                                  delete copy[`${name}-CGST`];
                                                  delete copy[`${name}-SGST`];
                                                  return copy;
                                              });
                                              const selectedSac = sacCodes.find(sac => sac.SAC_Code === value);
                                              if (selectedSac) {
                                                  // Get current values for this item to merge
                                                  const currentItems = form.getFieldValue('items') || [];
                                                  const currentItem = currentItems[name] || {};

                                                  if (taxType === 'IGST') {
                                                      // Explicitly set IGST to GST_Value, reset CGST/SGST to 0
                                                      form.setFieldsValue({
                                                          items: {
                                                              ...currentItems,
                                                              [name]: {
                                                                  ...currentItem,
                                                                  SAC_Code: value,
                                                                  IGST: selectedSac.GST_Value,
                                                                  CGST: 0,
                                                                  SGST: 0,
                                                              },
                                                          },
                                                      });
                                                  } else if (taxType === 'CGST_SGST') {
                                                      const halfGST = selectedSac.GST_Value / 2;
                                                      // Explicitly set CGST/SGST half, reset IGST to 0
                                                      form.setFieldsValue({
                                                          items: {
                                                              ...currentItems,
                                                              [name]: {
                                                                  ...currentItem,
                                                                  SAC_Code: value,
                                                                  IGST: 0,     // This resets IGST properly
                                                                  CGST: halfGST,
                                                                  SGST: halfGST,
                                                              },
                                                          },
                                                      });
                                                  }
                                              }
                                          }}
                                      >
                                          {sacCodes.map(sac => (
                                              <Select.Option key={sac.SAC_Code} value={sac.SAC_Code}>
                                                  {sac.SAC_Code}
                                              </Select.Option>
                                          ))}
                                      </Select>
                                  </Form.Item>

                                  <Form.Item
                                      {...restField}
                                      name={[name, "Rate"]}
                                      rules={[{ required: true, message: "Rate is required" }]}
                                      style={{ flex: 1.5, marginBottom: 0 }}
                                  >
                                      <InputNumber min={0} placeholder="Rate" style={{ width: "100%" }} />
                                  </Form.Item>

                                  <Form.Item
                                      {...restField}
                                      name={[name, "Quantity"]}
                                      rules={[{ required: true, message: "Qty is required" }]}
                                      style={{ flex: 1.2, marginBottom: 0 }}
                                  >
                                      <InputNumber min={1} placeholder="Qty" style={{ width: "100%" }} />
                                  </Form.Item>



                                  {/* CGST % Field */}
                                  <Form.Item shouldUpdate style={{ flex: 1, marginBottom: 0 }}>
                                      {({ getFieldValue }) => {
                                          const itemIGST = getFieldValue(['items', name, 'IGST']) || 0;
                                          const disableCGST_SGST = Number(itemIGST) > 0;
                                          return (
                                              <Form.Item
                                                  name={[name, 'CGST']}
                                                  style={{ marginBottom: 0 }}
                                                  noStyle
                                              >
                                                  <InputNumber
                                                      min={0}
                                                      placeholder="CGST%"
                                                      style={{ width: "100%" }}
                                                      disabled={disableCGST_SGST}
                                                      onChange={() => setManualGSTEdit(prev => ({ ...prev, [`${name}-CGST`]: true }))}
                                                  />

                                              </Form.Item>
                                          );
                                      }}
                                  </Form.Item>

                                  {/* SGST % Field */}
                                  <Form.Item shouldUpdate style={{ flex: 1, marginBottom: 0 }}>
                                      {({ getFieldValue }) => {
                                          const itemIGST = getFieldValue(['items', name, 'IGST']) || 0;
                                          return (
                                              <Form.Item
                                                  name={[name, 'SGST']}
                                                  style={{ marginBottom: 0 }}
                                                  noStyle
                                              >
                                                  <InputNumber
                                                      min={0}
                                                      placeholder="SGST%"
                                                      style={{ width: "100%" }}
                                                      disabled={Number(itemIGST) > 0}
                                                      onChange={() => setManualGSTEdit(prev => ({ ...prev, [`${name}-SGST`]: true }))}
                                                  />

                                              </Form.Item>
                                          );
                                      }}
                                  </Form.Item>

                                  {/* IGST % Field */}
                                  <Form.Item shouldUpdate style={{ flex: 1, marginBottom: 0 }}>
                                      {({ getFieldValue, setFieldsValue }) => {
                                          const itemCGST = getFieldValue(['items', name, 'CGST']) || 0;
                                          const itemSGST = getFieldValue(['items', name, 'SGST']) || 0;
                                          const itemSACCode = getFieldValue(['items', name, 'SAC_Code']);

                                          const selectedSac = sacCodes.find(sac => sac.SAC_Code === itemSACCode);
                                          const gstValue = selectedSac ? selectedSac.GST_Value : 0;

                                          const currentIGST = getFieldValue(['items', name, 'IGST']) || 0;

                                          // Assuming taxType is accessible in scope here:
                                          if (itemSACCode && !manualGSTEdit[`${name}-IGST`]) {
                                              if (taxType === 'IGST') {
                                                  // Set IGST to GST_Value if different
                                                  if (currentIGST !== gstValue) {
                                                      setFieldsValue({
                                                          items: {
                                                              [name]: {
                                                                  IGST: gstValue
                                                              }
                                                          }
                                                      });
                                                  }
                                              } else if (taxType === 'CGST_SGST') {
                                                  // Set IGST to zero when CGST/SGST selected and IGST not zero
                                                  if (currentIGST !== 0) {
                                                      setFieldsValue({
                                                          items: {
                                                              [name]: {
                                                                  IGST: 0
                                                              }
                                                          }
                                                      });
                                                  }
                                              }
                                          }

                                          return (
                                              <Form.Item
                                                  name={[name, 'IGST']}
                                                  style={{ marginBottom: 0 }}
                                                  noStyle
                                              >
                                                  <InputNumber
                                                      min={0}
                                                      placeholder="IGST%"
                                                      style={{ width: "100%" }}
                                                      disabled={Number(itemCGST) > 0 || Number(itemSGST) > 0}
                                                      onChange={() => setManualGSTEdit(prev => ({ ...prev, [`${name}-IGST`]: true }))}
                                                  />

                                              </Form.Item>
                                          );
                                      }}
                                  </Form.Item>




                            {/* Display the Total amount field (read-only or disabled input) */}
                          <Form.Item shouldUpdate={(prevValues, curValues) => {
                            const prevItem = prevValues.items?.[name];
                            const curItem = curValues.items?.[name];
                            return (
                                prevItem?.Rate !== curItem?.Rate ||
                                prevItem?.CGST !== curItem?.CGST ||
                                prevItem?.SGST !== curItem?.SGST ||
                                prevItem?.IGST !== curItem?.IGST
                            );
                          }} noStyle>
                            {({ getFieldValue }) => {
                              const rate = Number(getFieldValue(['items', name, 'Rate'])) || 0;
                              const quantity = Number(getFieldValue(['items', name, 'Quantity'])) || 0;
                              const cgst = Number(getFieldValue(['items', name, 'CGST'])) || 0;
                              const sgst = Number(getFieldValue(['items', name, 'SGST'])) || 0;
                              const igst = Number(getFieldValue(['items', name, 'IGST'])) || 0;

                              // Calculate total: Rate * (1 + sum of taxes/100)
                              const taxMultiplier = (cgst + sgst + igst) / 100;
                              const total = rate * quantity * (1 + taxMultiplier);

                              return (
                                  <Form.Item style={{ flex: 1, marginBottom: 0 }}>
                                    <InputNumber
                                        value={total.toFixed(2)}
                                        readOnly
                                        disabled
                                        style={{ width: "100%", backgroundColor: "#f5f5f5" }}
                                        placeholder="Total"
                                    />
                                  </Form.Item>
                              );
                            }}
                          </Form.Item>

                          <Button
                              danger
                              onClick={() => remove(name)}
                              icon={<span style={{ fontWeight: 'bold' }}>−</span>}
                              style={{ flex: 1, minWidth: 32 }}
                              disabled={fields.length === 1}
                          />
                        </div>
                    ))}

                    <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<span style={{ fontWeight: 'bold' }}>+</span>}
                        style={{ marginTop: 8 }}
                    >
                      Add Item
                    </Button>

                    <Form.Item shouldUpdate={(prevValues, curValues) => {
                      const prevItems = prevValues.items || [];
                      const curItems = curValues.items || [];

                      if (prevItems.length !== curItems.length) return true;

                      for (let i = 0; i < prevItems.length; i++) {
                        if (
                            prevItems[i]?.Rate !== curItems[i]?.Rate ||
                            prevItems[i]?.Quantity !== curItems[i]?.Quantity ||
                            prevItems[i]?.CGST !== curItems[i]?.CGST ||
                            prevItems[i]?.SGST !== curItems[i]?.SGST ||
                            prevItems[i]?.IGST !== curItems[i]?.IGST
                        ) {
                          return true;
                        }
                      }

                      return false;
                    }} noStyle>
                      {({ getFieldValue }) => {
                        const items = getFieldValue('items') || [];
                        let invoiceTotal = 0;
                        items.forEach(item => {
                          if (item) {
                            const rate = Number(item.Rate) || 0;
                            const quantity = Number(item.Quantity) || 0;
                            const cgst = Number(item.CGST) || 0;
                            const sgst = Number(item.SGST) || 0;
                            const igst = Number(item.IGST) || 0;
                            const taxMultiplier = (cgst + sgst + igst) / 100;
                            const itemTotal = rate * quantity * (1 + taxMultiplier);
                            invoiceTotal += itemTotal;
                          }
                        });
                        return (
                            <Form.Item
                                style={{
                                  marginTop: 16,
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                  gap: 8,           // smaller gap between label and input
                                  maxWidth: 250,    // optional: limit total width to avoid stretching too far right
                                  marginLeft: 'auto' // push the whole Form.Item container to the right
                                }}
                                labelCol={{ flex: '0 0 auto' }}   // no fixed width, shrink to content
                                wrapperCol={{ flex: '0 0 auto' }} // no fixed width, shrink to content
                                label={<span style={{ fontWeight: 'bold', textAlign: 'right', whiteSpace: 'nowrap' }}>Invoice Total</span>}
                            >
                              <InputNumber
                                  value={invoiceTotal.toFixed(2)}
                                  readOnly
                                  disabled
                                  style={{
                                    width: 120,        // fixed width matching item total input width
                                    backgroundColor: '#f5f5f5',
                                    textAlign: 'right',
                                    paddingRight: 8    // slight padding inside input for better look
                                  }}
                                  placeholder="Invoice Total"
                              />
                            </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </>
              )}
            </Form.List>
              <Form.Item name="OtherReference" label="Special Instruction">
                  <Input />
              </Form.Item>
              <Form.Item
                  name="RefNoDate"
                  label="Approver_Email"
                  rules={[
                      { required: true, message: 'Approver email is required' },
                      { type: 'email', message: 'Enter a valid email address' },
                  ]}
              >
                  <Input />
              </Form.Item>

          </Form>
        </Modal>
          {/* Alert Modal inside Add Sales Invoice for adding Customer manually combo  */}
          <Modal
              visible={confirmVisible}
              title="Confirm New Customer Insertion"
              onOk={onConfirmOk}
              zIndex={1500}   // Always on top
              onCancel={() => {
                  isCheckingRef.current = false;
                  setConfirmVisible(false);
              }}
          >
              <p>Name: {newCustomerData?.CustomerName}</p>
              <p>Location: {newCustomerData?.Location}</p>
              <p>CustomerAddress: {newCustomerData?.CustomerAddress}</p>
              <p>PAN: {newCustomerData?.PAN}</p>
              <p>GST: {newCustomerData?.GST}</p>
              <p>Do you want to add this as a new customer?</p>
              <p><b>If yes, then select new customer from drop down after  clicking ok and clearing field</b></p>
          </Modal>

        {/* Invoice Details Modal */}
        <Modal
            open={invoiceDetailVisible}
            onCancel={() => setInvoiceDetailVisible(false)}
            title={invoiceDetail ? `Invoice# ${invoiceDetail.InvoiceNumber}` : "Invoice Details"}
            width={900}
            footer={null}
        >
          {invoiceDetail && (
              <div>
                <h3><b>Invoice Details</b></h3>
                <Row gutter={24}>
                  <Col span={12}>
                    <p><b>Invoice Number:</b> {invoiceDetail.InvoiceNumber}</p>
                    <p><b>Date:</b> {invoiceDetail.Date}</p>
                    <p><b>Customer:</b> {getCustomerName(invoiceDetail.CustomerID)}</p>
                      <p><b>Location:</b> {getCustomerLocation(invoiceDetail.CustomerID)}</p>
                      <p>
                          <b>Client_Updated: </b>
                          <span style={{ color:
                                  invoiceDetail.Client_Updated === 'Y' ? 'green' : 'red',
                              fontWeight: 'bold'
                          }}>
        {invoiceDetail.Client_Updated || 'Empty'}
      </span>
                      </p>
                  </Col>
                  <Col span={12}>
                    <p><b>PO Number:</b> {invoiceDetail.PO_Number}</p>
                    <p><b>PO Date:</b> {invoiceDetail.PO_Date}</p>
                    <p><b>PO Remaining Amount:</b> {invoiceDetail.PO_Remaining_Amount}</p>
                    <p><b>Dispatched Via:</b> {invoiceDetail.Dispatched_Via}</p>
                    <p><b>Destination:</b> {invoiceDetail.Destination}</p>
                  </Col>
                </Row>
                  <b>Special Instructions:</b> {invoiceDetail.OtherReference}
                  <p><b>Approver_Email:</b> {invoiceDetail.RefNoDate}</p>
                <hr />
                <h3><b>Amounts</b></h3>
                <Row gutter={24}>
                  <Col span={8}>
                    <p><b>Rate Amount:</b> {Math.round(invoiceDetail.RateAmount || 0)}</p>
                  </Col>
                  <Col span={8}>
                    <p><b>Tax Amount:</b> {Math.round(invoiceDetail.TaxAmount || 0)}</p>
                  </Col>
                  <Col span={8}>
                    <p><b>Total Amount:</b> {Math.round(invoiceDetail.TotalAmount)}</p>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <p><b>Status:</b> {invoiceDetail.Status}</p>
                  </Col>
                </Row>
                <hr />
                <h3><b>Invoice Items</b></h3>
                <Table
                    dataSource={invoiceDetailItems}
                    columns={[
                      { title: "Item Name", dataIndex: "ItemName" },
                      { title: "UOM", dataIndex: "UOM" },
                      { title: "SAC Code", dataIndex: "SAC_Code" },
                      { title: "Rate", dataIndex: "Rate" },
                      { title: "Quantity", dataIndex: "Quantity" },
                      { title: "Rate Amount", dataIndex: "RateAmount" },
                      { title: "CGST (%)", dataIndex: "CGST" },
                      { title: "SGST (%)", dataIndex: "SGST" },
                      { title: "IGST (%)", dataIndex: "IGST" },
                      { title: "Tax Amount", dataIndex: "TaxAmount" },
                      {
                        title: "Total",
                        dataIndex: "Total",
                        render: (value, record) =>
                            value !== undefined
                                ? value
                                : (Number(record.RateAmount) || 0) + (Number(record.TaxAmount) || 0)
                      }
                    ]}
                    rowKey="ItemID"
                    pagination={false}
                    size="small"
                />
              </div>
          )}
        </Modal>
      </Card>
        </>
  );
}
